import { render, staticRenderFns } from "./researchNewsPage.vue?vue&type=template&id=bacc7c3e&"
import script from "./researchNewsPage.vue?vue&type=script&lang=js&"
export * from "./researchNewsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports